import { render, staticRenderFns } from "./Ditron.vue?vue&type=template&id=2bef9854&scoped=true&"
import script from "./Ditron.vue?vue&type=script&lang=js&"
export * from "./Ditron.vue?vue&type=script&lang=js&"
import style0 from "./Ditron.vue?vue&type=style&index=0&id=2bef9854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef9854",
  null
  
)

export default component.exports